// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colors */
:root {
  --main-col1: #092540; /* oxford blue */
  --main-col2: #C2F2FE;
  --main-col3: #1fdaff; /* sky blue */
  --main-col4: #EFA780; /* sky blue */
  --main-col5: #F8DDC9; /* sky blue */
  --emph-col: #ff600a; /* orange pantone */
  --back-col: #ffffff; /* white */
  --light-col: #ebebeb; /* light gray = platinum */
  --texthover-col: #973fb0;
  --shadow-col: #e4e4e4;
}

/* Borders and Spacing */
:root {
  --border-radius: 25px;
  --font-size-sml: 0.875rem;
  --margin-sml: 0.25em;
  --margin-md: 0.5em;
  --margin-lg: 1em;
  --margin-xlg: 1.5em;
  --padding-sml: 0.2em;
  --padding-md: 0.5em;
  --padding-lg: 1em;
  --padding-xlg: 1.5em;
}

/* Media Size */
:root {
  --media-size: 800px;
}

/* Nav Styles */
nav {
  height: 100%;
}

/* Full Site Styles */
.full-site {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  padding-top: 150px;
  padding-bottom: 150px;
  box-sizing: border-box; /* Crucial for preventing padding from overflowing */
}

/* Main Styles */
main {
  min-height: calc(100vh - 200px);
}

/* Header Styles */
h2 {
  font-size: 25px;
  color: black;
  font-family: 'Nunito', sans-serif;
  font-weight: 600;
  font-style: black;
  line-height: 1.1;
  text-align: center;
}

@media screen and (max-width: 899.99px) {
  h2 {
    font-size: 20px;
    color: black;
    font-family: 'Nunito', sans-serif;
    font-style: black;
    font-weight: 600;
    line-height: 1.1;
    text-align: center;
  }
}


/* Generic Text Styles */
span {
  font-family: Nunito, sans-serif; 
  font-size: 14px;
  color: black;
}


.boldfont {
  font-family: 'Nunito', sans-serif;
  font-style: black;
  font-weight: 800;
}


/* Italic Font Styles */
.italicfont {
  font-family: 'Nunito', sans-serif;
  font-style: italic;
}


/* Regular Paragraph Styles */
p {
  font-size: 16px;
  color: black;
  font-family: 'Nunito', sans-serif;
  line-height: 1.1;
  text-align: left;
}

@media screen and (max-width: 899.99px) {
  p {
    font-size: 14px;
    color: black;
    font-family: 'Nunito', sans-serif;
    text-align: left;
  }
}


.handwriting {
  font-size: 22px;
  color: black;
  font-family: 'Gaegu', sans-serif;
  font-style: normal;
  /* line-height: 1.1; */
  text-align: left;
}

@media screen and (max-width: 899.99px) {
  .handwriting {
    font-size: 20px;
    color: black;
    font-family: 'Gaegu', sans-serif;
    font-style: normal;
    text-align: left;
  }
}

.iconfont {
  font-size: 22px;
  color: black;
  font-family: 'Nunito', sans-serif;
  font-style: black;
  font-weight: 800; /* ExtraBold */
  /* line-height: 1.1; */
  text-align: left;
}

@media screen and (max-width: 899.99px) {
  .iconfont {
    font-size: 20px;
    color: black;
    font-family: 'Nunito', sans-serif;
    font-style: black;
    font-weight: 800; /* ExtraBold */
    text-align: left;
  }
}


/* Legal page wrapper */
.legal-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 48px 20px 80px;
}

@media screen and (max-width: 899.99px) {
  .legal-page {
    padding: 28px 16px 64px;
  }
}

/* Title */
.legal-title {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 34px;
  line-height: 1.15;
  margin: 0 0 22px;
  text-align: center;
}

/* Section headings */
.legal-h2 {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 18px;
  margin: 26px 0 10px;
  line-height: 1.25;
  text-align: left;
}

.legal-h3 {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 16px;
  margin: 18px 0 8px;
  line-height: 1.25;
}

/* Body text */
.legal-page p,
.legal-page li {
  font-family: "Nunito", sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: #111;
}

@media screen and (max-width: 899.99px) {
  .legal-page p,
  .legal-page li {
    font-size: 14px;
    line-height: 1.65;
  }
}

/* Lists */
.legal-list {
  margin: 10px 0 14px;
  padding-left: 20px;
}

.legal-list li {
  margin: 6px 0;
}

/* Last updated */
.legal-updated {
  margin-top: 28px;
  color: #737789 !important;
  font-size: 13px;
}


.legal-sublist {
  margin-top: 8px;
  padding-left: 24px;
}

.legal-sublist > li {
  margin: 6px 0;
}

.legal-subsublist {
  margin-top: 6px;
  padding-left: 24px;
}

.legal-subsublist > li {
  margin: 4px 0;
}

/* Delete Account Component Styles */
.full-site p,
.full-site li {
  font-family: 'Nunito', sans-serif;
  color: black;
  text-align: left;
}

.full-site ol {
  display: inline-block;
  text-align: left;
  margin: 0 auto;
}
.full-site p,
.full-site li {
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: #111;
}

@media screen and (max-width: 899.99px) {
  .full-site p,
  .full-site li {
    font-size: 14px;
    line-height: 1.65;
  }
}`, "",{"version":3,"sources":["webpack://./frontend/src/styles/_base.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,oBAAoB,EAAE,gBAAgB;EACtC,oBAAoB;EACpB,oBAAoB,EAAE,aAAa;EACnC,oBAAoB,EAAE,aAAa;EACnC,oBAAoB,EAAE,aAAa;EACnC,mBAAmB,EAAE,mBAAmB;EACxC,mBAAmB,EAAE,UAAU;EAC/B,oBAAoB,EAAE,0BAA0B;EAChD,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB,EAAE,oDAAoD;AAC9E;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;;AAGA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;;AAGA,6BAA6B;AAC7B;EACE,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;EAClB;AACF;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB,EAAE,cAAc;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB,EAAE,cAAc;IAChC,gBAAgB;EAClB;AACF;;;AAGA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,UAAU;AACV;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,cAAc;AACd;;EAEE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;;EAEE,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Colors */\n:root {\n  --main-col1: #092540; /* oxford blue */\n  --main-col2: #C2F2FE;\n  --main-col3: #1fdaff; /* sky blue */\n  --main-col4: #EFA780; /* sky blue */\n  --main-col5: #F8DDC9; /* sky blue */\n  --emph-col: #ff600a; /* orange pantone */\n  --back-col: #ffffff; /* white */\n  --light-col: #ebebeb; /* light gray = platinum */\n  --texthover-col: #973fb0;\n  --shadow-col: #e4e4e4;\n}\n\n/* Borders and Spacing */\n:root {\n  --border-radius: 25px;\n  --font-size-sml: 0.875rem;\n  --margin-sml: 0.25em;\n  --margin-md: 0.5em;\n  --margin-lg: 1em;\n  --margin-xlg: 1.5em;\n  --padding-sml: 0.2em;\n  --padding-md: 0.5em;\n  --padding-lg: 1em;\n  --padding-xlg: 1.5em;\n}\n\n/* Media Size */\n:root {\n  --media-size: 800px;\n}\n\n/* Nav Styles */\nnav {\n  height: 100%;\n}\n\n/* Full Site Styles */\n.full-site {\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  padding-top: 150px;\n  padding-bottom: 150px;\n  box-sizing: border-box; /* Crucial for preventing padding from overflowing */\n}\n\n/* Main Styles */\nmain {\n  min-height: calc(100vh - 200px);\n}\n\n/* Header Styles */\nh2 {\n  font-size: 25px;\n  color: black;\n  font-family: 'Nunito', sans-serif;\n  font-weight: 600;\n  font-style: black;\n  line-height: 1.1;\n  text-align: center;\n}\n\n@media screen and (max-width: 899.99px) {\n  h2 {\n    font-size: 20px;\n    color: black;\n    font-family: 'Nunito', sans-serif;\n    font-style: black;\n    font-weight: 600;\n    line-height: 1.1;\n    text-align: center;\n  }\n}\n\n\n/* Generic Text Styles */\nspan {\n  font-family: Nunito, sans-serif; \n  font-size: 14px;\n  color: black;\n}\n\n\n.boldfont {\n  font-family: 'Nunito', sans-serif;\n  font-style: black;\n  font-weight: 800;\n}\n\n\n/* Italic Font Styles */\n.italicfont {\n  font-family: 'Nunito', sans-serif;\n  font-style: italic;\n}\n\n\n/* Regular Paragraph Styles */\np {\n  font-size: 16px;\n  color: black;\n  font-family: 'Nunito', sans-serif;\n  line-height: 1.1;\n  text-align: left;\n}\n\n@media screen and (max-width: 899.99px) {\n  p {\n    font-size: 14px;\n    color: black;\n    font-family: 'Nunito', sans-serif;\n    text-align: left;\n  }\n}\n\n\n.handwriting {\n  font-size: 22px;\n  color: black;\n  font-family: 'Gaegu', sans-serif;\n  font-style: normal;\n  /* line-height: 1.1; */\n  text-align: left;\n}\n\n@media screen and (max-width: 899.99px) {\n  .handwriting {\n    font-size: 20px;\n    color: black;\n    font-family: 'Gaegu', sans-serif;\n    font-style: normal;\n    text-align: left;\n  }\n}\n\n.iconfont {\n  font-size: 22px;\n  color: black;\n  font-family: 'Nunito', sans-serif;\n  font-style: black;\n  font-weight: 800; /* ExtraBold */\n  /* line-height: 1.1; */\n  text-align: left;\n}\n\n@media screen and (max-width: 899.99px) {\n  .iconfont {\n    font-size: 20px;\n    color: black;\n    font-family: 'Nunito', sans-serif;\n    font-style: black;\n    font-weight: 800; /* ExtraBold */\n    text-align: left;\n  }\n}\n\n\n/* Legal page wrapper */\n.legal-page {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 48px 20px 80px;\n}\n\n@media screen and (max-width: 899.99px) {\n  .legal-page {\n    padding: 28px 16px 64px;\n  }\n}\n\n/* Title */\n.legal-title {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 800;\n  font-size: 34px;\n  line-height: 1.15;\n  margin: 0 0 22px;\n  text-align: center;\n}\n\n/* Section headings */\n.legal-h2 {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 800;\n  font-size: 18px;\n  margin: 26px 0 10px;\n  line-height: 1.25;\n  text-align: left;\n}\n\n.legal-h3 {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 800;\n  font-size: 16px;\n  margin: 18px 0 8px;\n  line-height: 1.25;\n}\n\n/* Body text */\n.legal-page p,\n.legal-page li {\n  font-family: \"Nunito\", sans-serif;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #111;\n}\n\n@media screen and (max-width: 899.99px) {\n  .legal-page p,\n  .legal-page li {\n    font-size: 14px;\n    line-height: 1.65;\n  }\n}\n\n/* Lists */\n.legal-list {\n  margin: 10px 0 14px;\n  padding-left: 20px;\n}\n\n.legal-list li {\n  margin: 6px 0;\n}\n\n/* Last updated */\n.legal-updated {\n  margin-top: 28px;\n  color: #737789 !important;\n  font-size: 13px;\n}\n\n\n.legal-sublist {\n  margin-top: 8px;\n  padding-left: 24px;\n}\n\n.legal-sublist > li {\n  margin: 6px 0;\n}\n\n.legal-subsublist {\n  margin-top: 6px;\n  padding-left: 24px;\n}\n\n.legal-subsublist > li {\n  margin: 4px 0;\n}\n\n/* Delete Account Component Styles */\n.full-site p,\n.full-site li {\n  font-family: 'Nunito', sans-serif;\n  color: black;\n  text-align: left;\n}\n\n.full-site ol {\n  display: inline-block;\n  text-align: left;\n  margin: 0 auto;\n}\n.full-site p,\n.full-site li {\n  font-family: 'Nunito', sans-serif;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #111;\n}\n\n@media screen and (max-width: 899.99px) {\n  .full-site p,\n  .full-site li {\n    font-size: 14px;\n    line-height: 1.65;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
